//@flow
import type { ReducerState$Type,EditFormData } from './flowTypes'

export const transformDataToEditFormData=(data:any,demeter: ReducerState$Type)=>{
    let formData: EditFormData = {}
    
    const demeterHeaderData = data['demeterHeader']
    formData.isInvalidDoc = demeterHeaderData['is_invalid_doc']?demeterHeaderData['is_invalid_doc']:false
    formData.isOverrideVendorName = demeterHeaderData['is_override_vendor_name']?demeterHeaderData['is_override_vendor_name']:false
    formData.isOverrideShipTo = demeterHeaderData['is_override_ship_to']?demeterHeaderData['is_override_ship_to']:false
    formData.isOverrideInvTotal = demeterHeaderData['is_override_inv_total']?demeterHeaderData['is_override_inv_total']:false

    if (demeterHeaderData['inv_no']){
        formData.invNo = demeterHeaderData['inv_no']
    }
    if (demeterHeaderData['inv_date']){
        formData.invDate = demeterHeaderData['inv_date']
    }
    if (demeterHeaderData['po_no']){
        formData.poNo = demeterHeaderData['po_no']
    }
    if (demeterHeaderData['approval_code']){
        formData.approvalCode = demeterHeaderData['approval_code']
    }
    if (demeterHeaderData['inv_total']){
        formData.invoiceTotal = parseFloat(demeterHeaderData['inv_total'])
    }
    if (demeterHeaderData['store_id_code']){
        formData.storeIdCode = demeterHeaderData['store_id_code']
    }
    if (demeterHeaderData['ship_to_addr']){
        formData.shipToAddr = demeterHeaderData['ship_to_addr']
    }
    if (demeterHeaderData['vendor_id_code']){
        formData.vendorIdCode = demeterHeaderData['vendor_id_code']
    }
    if (demeterHeaderData['vendor_name']){
        formData.vendorName = demeterHeaderData['vendor_name']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/demeter/editFormData.js